interface PropertyType {
  id: string;
  label: string;
  icon: string;
}

interface PropertyTypeSelectorProps {
  propertyTypes: PropertyType[];
  selectedType: string;
  onSelect: (typeId: string) => void;
}

export default function PropertyTypeSelector({ propertyTypes, selectedType, onSelect }: PropertyTypeSelectorProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {propertyTypes.map((type) => (
        <button
          key={type.id}
          onClick={() => onSelect(type.id)}
          className={`p-4 rounded-lg border-2 transition-all duration-300 ${
            selectedType === type.id
              ? 'border-primary bg-primary/5 shadow-md'
              : 'border-border hover:border-primary/50 hover:shadow-sm'
          }`}
        >
          <div className="flex flex-col items-center space-y-2">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
              selectedType === type.id ? 'bg-primary text-primary-foreground' : 'bg-surface text-foreground'
            }`}>
              <span className="text-2xl">{type.icon}</span>
            </div>
            <span className={`text-sm font-heading font-medium text-center ${
              selectedType === type.id ? 'text-primary' : 'text-foreground'
            }`}>
              {type.label}
            </span>
          </div>
        </button>
      ))}
    </div>
  );
}